import {
  QUALIFY_STATUS_ERROR,
  QUALIFY_STATUS_SUCCESS,
  QUALIFY_STATUS_LOADING,
} from '@/app/qualify/store/types';

export const mutations = {
  [QUALIFY_STATUS_SUCCESS]: (state, response) => {
    state.qualifyLoadingStatus = 'success';
    state.qualifyStatus = response;
  },
  [QUALIFY_STATUS_LOADING]: (state) => {
    state.qualifyLoadingStatus = 'loading';
  },
  [QUALIFY_STATUS_ERROR]: (state) => {
    state.qualifyLoadingStatus = 'error';
  },
};
